import PropTypes from 'prop-types'
import { memo, useCallback, useMemo } from 'react'
import { useUserContext } from 'app/services/UserProvider/UserProvider'
import Content from 'components/content/Content/Content'
import Layout from 'components/core/Layout/Layout'
import ButtonActivity from 'components/elements/ButtonActivity/ButtonActivity'
import { useModalContext } from 'components/interface/Modal/provider/ModalProvider'
import styles from './RetryLogin.module.scss'

/**
 * The `RetryLogin`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
function RetryLogin (props) {
  const { isModalContentActive } = useModalContext()
  const { account, refreshAccountStatus, userActivityStatus } =
    useUserContext()
  const { className } = props

  const content = useMemo(
    () => [
      {
        type: 'standard',
        align: 'center',
        content: `<p>There was a problem during authentication.</p><p class="${
          styles.reason
        }">Reason: ${account?.accountLoginErrorMessage || 'Unknown'}</p>`
      }
    ],
    [account]
  )

  /**
   * Handle retry logging in
   */
  const handleRetry = useCallback(async () => {
    if (userActivityStatus) {
      // Busy
      return
    }

    refreshAccountStatus()
  }, [userActivityStatus])

  return (
    <div className={`${styles.retryLogin} ${className}`.trimEnd()}>
      <Layout.Body className={styles.retryLoginInfo}>
        <Content items={content} isActive={isModalContentActive} />
      </Layout.Body>

      <div className={styles.retryLoginOptions}>
        <ButtonActivity
          isBusy={!!userActivityStatus}
          size="large"
          color="a"
          onClick={handleRetry}
          side="left"
          useHighlight={true}
          borderRadius="c"
        >
          Retry
        </ButtonActivity>
      </div>
    </div>
  )
}

/** @type {object} */
RetryLogin.propTypes = {
  className: PropTypes.string
}

/** @type {object} */
RetryLogin.defaultProps = {
  className: ''
}

// Memoize
export default memo(RetryLogin)
